import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

export default function RequireCompany() {
  const navigate = useNavigate();
  const companyId = localStorage.getItem('selectedCompanyId');

  if (!companyId) {
    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', height: '80vh', padding: '40px',
        textAlign: 'center', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}>
        <div style={{ fontSize: '64px', marginBottom: '20px' }}>🏢</div>
        <h2 style={{ color: '#1a1a2e', marginBottom: '10px', fontSize: '22px', fontWeight: 600 }}>
          No Company Selected
        </h2>
        <p style={{ color: '#666', fontSize: '15px', marginBottom: '24px', maxWidth: '420px', lineHeight: 1.5 }}>
          Please select a company from the dropdown in the sidebar to access this page.
        </p>
        <button
          onClick={() => navigate('/')}
          style={{
            padding: '10px 24px', backgroundColor: '#3b82f6', color: '#fff',
            border: 'none', borderRadius: '8px', cursor: 'pointer',
            fontSize: '14px', fontWeight: 500
          }}
        >
          ← Go to Holding Overview
        </button>
      </div>
    );
  }

  return <Outlet />;
}
